export const CAMPAIGN_SITE_FILTER_ID = 'CampaignSite';
export const CAMPAIGN_SITE_FILTER_VALUE_AMAZON_BUSINESS = 'AmazonBusiness';
export const MARKETPLACE_IDS_FILTER_ID = 'MarketplaceIds';
export const MARKETPLACE_FILTER_KEY = 'MarketplaceId';
export const REPORT_NAME_FILTER_KEY = 'ReportName';
export const REPORT_NAME_FILTER_VALUE_KEY = 'Name';
export const REPORT_STATUS_FILTER_KEY = 'ReportStatus';
export const REPORT_STATUS_FILTER_VALUE_KEY = 'Status';
export const REPORT_CATEGORY_KEY = 'ReportCategory';
export const ACCOUNTS_FILTER_KEY = 'Accounts';
export const ACCOUNTS_FILTER_ADVERTISER_ID_VALUE_KEY = 'AdvertiserId';
export const MRC_ACCREDITATION_STATUS_FILTER_ID = 'mrcAccreditationStatus';
export const MRC_ACCREDITATION_STATUS_FILTER_VALUE_SIVT = 'sivt_accreditation';
